var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12713 4.74407C7.58759 5.14284 7.58759 5.85716 7.12713 6.25593L2.15465 10.5622C1.50701 11.1231 0.499999 10.663 0.499999 9.80629L0.5 1.19371C0.5 0.336957 1.50701 -0.123095 2.15465 0.437781L7.12713 4.74407Z",
    fill: "#444859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonRight);
export default __webpack_public_path__ + "static/media/polygon-right.f76a98d8e0995da88ae0129857652d3e.svg";
export { ForwardRef as ReactComponent };